import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import BillingExclusionForm from '../../components/Billing/BillingExclusions/BillingExclusionList';

const BillingExclusionsPage = () => {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const navigate = useNavigate();
    const theme = useTheme();

    const handleBackButton = () => {
        navigate(-1);
    };

    return (
        <Grid
            sx={{
                width: '100%',
                height: isMobile ? '100%' : '80%',
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            <BillingExclusionForm />

            <CustomButton
                onClick={handleBackButton}
                color='primary'
                sx={{
                    marginLeft: !isMobile ? '-8px' : '-18px',
                    '&:hover': {
                        cursor: 'pointer',
                        color: theme.palette.textAccent.main,
                        backgroundColor: 'transparent',
                        background: 'none',
                    },
                }}
            >
                <ArrowBackIcon />{' '}
                {isMobile ? null : (
                    <Typography
                        sx={{
                            fontSize: '12px',
                            paddingLeft: '5px',
                        }}
                    >
                        Back to Admin Centre
                    </Typography>
                )}
            </CustomButton>
        </Grid>
    );
};

export default BillingExclusionsPage;
